import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/factor-de-integracion-imss';

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFactoresSbc = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getFactorSbc = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFactorSbc = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Seguridad Social
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFactorSbc = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteFactorSbc = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Nivel de Estudio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarFactorSbc = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
